<!--
 * @Author: 王耀民
 * @Date: 2022/3/24 15:27
 * @Description: 团队成员详情弹窗
-->
<template>
  <el-dialog
    :visible="visible"
    :before-close="close"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    title="团队人员详情"
    class="member-detail-modal"
    width="900px"
  >

    <el-row style="padding-bottom: 10px">
      <div class="avatar">
        <img v-if="memberData.avatarAddress" :src="memberData.avatarAddress">
        <img v-else src="@/assets/public/gebilaowang.png">
      </div>
    </el-row>
    <el-row>
      <el-col :span="24" class="detail-item">
        <span class="item-name">所属工队：</span>
        <span class="item-value">{{ memberData.teamName }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12" class="detail-item">
        <span class="item-name">姓名：</span>
        <span class="item-value">{{ memberData.name }}</span>
      </el-col>
      <el-col :span="12" class="detail-item" v-if="memberData.contactPhone">
        <span class="item-name">联系电话：</span>
        <span class="item-value">{{ memberData.contactPhone }}</span>
      </el-col>
      <el-col :span="12" class="detail-item" v-if="memberData.identity">
        <span class="item-name">身份证号：</span>
        <span class="item-value">{{ memberData.identity }}</span>
      </el-col>
      <el-col :span="12" class="detail-item" v-if="memberData.nationName">
        <span class="item-name">民族：</span>
        <span class="item-value">{{ memberData.nationName }}</span>
      </el-col>
      <el-col :span="12" class="detail-item" v-if="memberData.address">
        <span class="item-name">籍贯：</span>
        <span class="item-value">{{ memberData.address }}</span>
      </el-col>
      <el-col :span="12" class="detail-item" v-if="memberData.birthDay">
        <span class="item-name">出生日期：</span>
        <span class="item-value">{{ formatDate(+memberData.birthDay) }}</span>
      </el-col>
      <el-col :span="12" class="detail-item" v-if="memberData.education">
        <span class="item-name">学历：</span>
        <span class="item-value">{{ memberData.education }}</span>
      </el-col>
      <el-col :span="12" class="detail-item" v-if="memberData.profession">
        <span class="item-name">专业：</span>
        <span class="item-value">{{ memberData.profession }}</span>
      </el-col>
      <el-col :span="12" class="detail-item" v-if="memberData.workType">
        <span class="item-name">工种：</span>
        <span class="item-value">{{ memberData.workType }}</span>
      </el-col>
      <el-col :span="12" class="detail-item" v-if="memberData.workingYear">
        <span class="item-name">工龄：</span>
        <span class="item-value">{{ memberData.workingYear }}年</span>
      </el-col>
      <el-col :span="12" class="detail-item" v-if="memberData.bank">
        <span class="item-name">开户银行：</span>
        <span class="item-value">{{ memberData.bank }}</span>
      </el-col>
      <el-col :span="12" class="detail-item" v-if="memberData.bankAccount">
        <span class="item-name">银行账号：</span>
        <span class="item-value">{{ memberData.bankAccount }}</span>
      </el-col>
      <el-col :span="12" class="detail-item" v-if="memberData.immediateFamily">
        <span class="item-name">直系亲属：</span>
        <span class="item-value">{{ memberData.immediateFamily }}</span>
      </el-col>
      <el-col :span="12" class="detail-item" v-if="memberData.emergencyContact">
        <span class="item-name">紧急联系人：</span>
        <span class="item-value">{{ memberData.emergencyContact }}</span>
      </el-col>
      <el-col :span="12" class="detail-item" v-if="memberData.emergencyContactNumber">
        <span class="item-name">紧急联系人电话：</span>
        <span class="item-value">{{ memberData.emergencyContactNumber }}</span>
      </el-col>
      <el-col :span="24" class="detail-item" style="display: flex;padding-bottom: 0;"
              v-if="memberData.certificates && memberData.certificates.length">
        <span class="c666 item-name">证书：</span>
        <span style="display:flex;flex-wrap: wrap">
            <div v-for="(file,index) in memberData.certificates" :key="index" class="file-item">
              <div class="certificates-name">
                <img src="@/assets/fileIcon/certificates.png" alt="">
                <span>{{ file.name }}</span>
              </div>
              <div class="file-item-container">
                  <img :src="fileIcon[file.fileName.split('.').pop().toLowerCase()]" alt="" class="file-icon">
                  <div class="file-info">
                    <div class="file-name">
                      <div class="fore">{{ file.fileName.slice(0, file.fileName.lastIndexOf('.')) }}</div>
                      <div class="back">.{{ file.fileName.split('.').pop() }}</div>
                    </div>
                    <div class="file-other">
                      <span class="file-size">{{ formatFileSize(file.fileSize) }}</span>
                      <span class="file-download" @click="$previewFile(file.picture)">预览</span>
                    </div>
                  </div>
                </div>
              </div>
          </span>
      </el-col>
      <el-col :span="24" class="detail-item" v-for="(field,index) in memberData.addField" :key="index" style="padding-bottom:0">
        <span class="item-name">{{ field.name }}：</span>
        <span class="item-value">{{ field.value }}</span>
      </el-col>
      <el-col :span="24" class="detail-item" style="display: flex;padding-bottom: 0;"
              v-if="memberData.fileList && memberData.fileList.length">
        <span class="c666 item-name">附件：</span>
        <span style="display:flex;flex-wrap: wrap">
            <div v-for="(file,index) in memberData.fileList" :key="index" class="file-items">
              <div class="file-item-container">
                  <img :src="fileIcon[file.name.split('.').pop().toLowerCase()]" alt="" class="file-icon">
                  <div class="file-info">
                    <div class="file-name">
                      <div class="fore">{{ file.name.slice(0, file.name.lastIndexOf('.')) }}</div>
                      <div class="back">.{{ file.name.split('.').pop() }}</div>
                    </div>
                    <div class="file-other">
                      <span class="file-size">{{ formatFileSize(file.size) }}</span>
                      <span class="file-preview" @click="$previewFile(file.fileUrl)">预览</span>
                    </div>
                  </div>
                </div>
              </div>
          </span>
      </el-col>
    </el-row>

  </el-dialog>
</template>

<script>
import {apiTeamDetail} from '@/api/apiTeamDetail'
import '@/utils/previewFile'

export default {
  name: "MemberDetailModal",
  data() {
    return {
      visible: false,
      memberData: {},
      fileIcon:{
        jpg:require('@/assets/fileIcon/image.png'),
        jpeg:require('@/assets/fileIcon/image.png'),
        png:require('@/assets/fileIcon/image.png'),
        pdf:require('@/assets/fileIcon/pdf.png'),
        zip:require('@/assets/fileIcon/zip.png'),
        rar:require('@/assets/fileIcon/zip.png'),
        doc:require('@/assets/fileIcon/word.png'),
        docx:require('@/assets/fileIcon/word.png'),
        xlsx:require('@/assets/fileIcon/xls.png'),
        xls:require('@/assets/fileIcon/xls.png'),
      }
    }
  },
  methods: {
    /**
     * 打开人员详情弹窗
     * @param no 成员no
     */
    async open(no) {
      this.visible = true
      const res = await apiTeamDetail.getTeamMembersDetail(no)
      if (res.data.code == 200) {
        this.memberData = res.data.data
        this.memberData.certificates && this.memberData.certificates.reverse()
        if (this.memberData.addField) {
          this.memberData.addField = this.memberData.addField.map(field => {
            return {
              name: Object.keys(field)[0],
              value: field[Object.keys(field)[0]],
            }
          })
        }
      } else {
        this.$message.error(`系统异常，请稍后再试`)
      }
    },
    /**
     * 格式化页面显示的文件大小
     * @param fileSize 文件大小
     */
    formatFileSize(fileSize = 0) {
      fileSize = Number(fileSize)
      if (fileSize / 1024 > 10) {
        return `${(fileSize / 1024).toFixed(2)}M`
      } else {
        return `${Math.ceil(fileSize)}kb`
      }
    },
    formatDate(date,template='YYYY年MM月DD日'){
      return moment(date).format(template)
    },
    // 关闭成员弹窗
    close() {
      this.visible = false
      this.memberData = {}
    },
  }
}
</script>

<style lang="scss" scoped>
.member-detail-modal {
  /deep/.el-dialog__title{
    line-height: 1;
  }
  /deep/ .el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid var(--FCe);
  }

  /deep/ .el-dialog__body {
    padding: 20px 20px 10px;
    border-top: none !important;
  }

  .avatar {
    width: 60px;
    height: 60px;

    > img {
      width: 100%;
      height: 100%;
    }
  }

  .detail-item {
    padding: 10px 0;
    display: flex;
    // align-items: center;
    .item-name {
      flex-shrink: 0;
      color: var(--FC6);
    }

    .item-value {
      color: var(--FC3);
    }
  }

  .file-item {
    margin: 0 10px 10px 0;
    padding: 10px;
    background-color: #F5F7FA;
    border-radius: 4px;
    .certificates-name {
      display: flex;
      align-items: center;
      padding: 0 10px 10px;
      font-size: 14px;
      line-height: 1;
      color: var(--FC0);

      >img {
        flex-shrink: 0;
        margin-right: 5px;
        width: 15px;
        height: 15px;
      }

      >span{
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 190px;
      }
    }

    .file-item-container {
      box-sizing: border-box;
      width: 236px;
      display: flex;
      // margin:0px 10px 10px 0px ;
      padding: 10px 20px 10px 10px;
      background-color: #FAFAFA;
      font-size: 14px;
      border-radius: 4px;

      .file-icon {
        width: 33px;
        height: 40px;
      }

      .file-info {
        flex: 1;
        padding-left: 10px;
        line-height: 1.2;

        .file-name {
          margin-bottom: 10px;
          display: flex;
          color: var(--FC3);

          .fore {
            max-width: 148px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }

          .back{
            flex-shrink: 0;
          }
        }

        .file-other {
          display: flex;
          justify-content: space-between;

          .file-size {
            color: var(--FC9);
          }

          .file-download {
            cursor: pointer;
            color: #0286df;
          }
        }
      }

    }
  }
   .file-items {
    .file-item-container {
      box-sizing: border-box;
      width: 236px;
      display: flex;
      margin:0px 10px 10px 0px ;
      padding: 10px 20px 10px 10px;
      background-color: #FAFAFA;
      font-size: 14px;
      border-radius: 4px;
      .file-icon {
        width: 33px;
        height: 40px;
      }
      .file-info {
        flex: 1;
        padding-left: 10px;
        line-height: 1.2;
        .file-name {
          margin-bottom: 10px;
          display: flex;
          color: var(--FC3);
          .fore {
            max-width: 148px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }
          .back{
            flex-shrink: 0;
          }
        }
        .file-other {
          display: flex;
          justify-content: space-between;
          .file-size {
            color: var(--FC9);
          }
          .file-preview {
            cursor: pointer;
            color: #0286df;
          }
        }
      }

    }
  }
}
</style>
